/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { useQuery,useLazyQuery,useMutation } from "@apollo/client";
import { useParams,useHistory } from "react-router-dom";
import { AdminContext } from "../../context/AdminContext/AdminContext";
import { GET_INFO_EVALUATION_PERFORMANCE_BY_ID,
         GET_INFO_USER_BY_ID_PERFORMANCE_EVAL,
         GET_INFO_USER_BY_LEADER_PERFORMANCE_EVAL,
         GET_INFO_USER_BY_ADMIN_PERFORMANCE_EVAL,
         SEND_URL_EMAIL_RESULTS_COLLABORATOR 
} from "../../Querys/performanceEvaluationResults/querys";
import { IColabortador } from "../../interfaces/PerformanceEvaluation.interface";
import { IPerformanceEvaluationInfoId } from '../../interfaces/PerformanceEvaluationResult.interface';
import SearcherColaboradorEval from "../PerformanceEvaluation/Components/SearcherColaboradorEval";
import InfoEvalPerformanceCollaborator from "../PerformanceEvaluationQualification/Components/InfoEvalPerformanceCollaborator";
import { Grid } from "@material-ui/core";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import SimpleBarPlot from "./components/Graphs/SimpleBarPlot";
import InfoEvaluationPerformance from "./components/InfoEvaluationPerformance";
import BtnsEvalResult from "./components/BtnsEvalResult";
import ResultsEvaluators from "./components/ResultsEvaluators";
import ModelsEvaluationResults from "./components/ModelsEvaluationResults";
import FortalezasPerformance from "./components/FortalezasPerformance";
import OpportunityAreas from "./components/OpportunityAreas";
import TableCollaborators from "./components/TableCollaboratorsEvalResults";
import SpiderChart from "./components/Graphs/SpiderChart";
import { SuccessfulAlert } from "../../alerts/successAlerts";
import { LoadingAlert } from "../../alerts/loadingAlerts";
import "./css/EvalPerformanceResult.css";
import { getContainerClassInfo, 
        getContainerClassQualification,
        getContainerTypeEval,
        infoCalif,
        convertDesviacionToString,
        calcularCumplimiento,
        minEsperadoTotal,
        getBarData,
        getSpiderConfig,
        getSpiderData,
         } from "./helpers/ResultsHelpers";
import _ from 'lodash';
interface propsPerformanceEvaluationResults{
  idPerformanceEval?:string
  idUser?:string
  typeUser?: string
}


const PerformanceEvaluationResults = ({idPerformanceEval,idUser,typeUser}:propsPerformanceEvaluationResults) => {
  const { adminState } = useContext(AdminContext)
  const [selected, setSelected] = useState<readonly number[]>([]);
  const [colEvalInit, setColEvalInit] = useState<IColabortador[]>([])
  const [ setArrayIncident] = useState([])
  const [arrayCollaborators, setArrayCollaborators] = useState<IColabortador[]>([]) 
  const [infoEvaluationPer, setInfoEvaluationPer] = useState<IPerformanceEvaluationInfoId[]>([]);
  const [infoEvaluationPerUser, setInfoEvaluationPerUser] = useState<any[]>([]); 
  const [infoEvaluationResults, setInfoEvaluationResults] = useState<any[]>([]); 
  const [infoEvalCompetenceResults, setInfoEvalCompetenceResults] = useState<any[]>([]); 
  const [viewForCollaborator, setViewForCollaborator] = useState(false); 
  const [calificacionNUm, setCalificacionNum] = useState(0); 
  const [calificacionTxt, setCalificacionTxt] = useState(''); 
  const [indicatorsReached, setIndicatorsReached] = useState(0); 
  const [selectIdColaborador, setSelectIdColaborador] = useState(0); 
  const [minEsperado, setMinEsperado] = useState(0); 
  
  const [mensajeColSel, setMensajeColSel] = useState('Seleccione un colaborador para ver sus resultados.'); 
  const [typeEval, setTypeEval] = useState(0)
  const { id } = useParams<{ id: string }>();
  const performanceEvalId = idPerformanceEval || id;
  const role = typeUser || 'admin';
  const history = useHistory();

  const [senColPErEvaResult] = useMutation(SEND_URL_EMAIL_RESULTS_COLLABORATOR);

  const { data: infoEvaluationPerformance } = useQuery(GET_INFO_EVALUATION_PERFORMANCE_BY_ID, {
    variables: { idPerEval:performanceEvalId }    
  });  
  const EvaluationPerformanceInfo = infoEvaluationPerformance?.GET_INFO_EVALUATION_PERFORMANCE_BY_ID;  
  
  useEffect(() => {
    if (EvaluationPerformanceInfo) {  
      setInfoEvaluationPer(EvaluationPerformanceInfo);
    }
  }, [EvaluationPerformanceInfo]);  

  const { data: infoUserEvaluationPerformance } = useQuery(
    GET_INFO_USER_BY_ID_PERFORMANCE_EVAL,
    {
      variables: { idUser: idUser ,idPerEval:performanceEvalId},
      skip: role !== 'collaborator', 
    }
  );  
   
  const EvaluationPerformanceInfoUser = infoUserEvaluationPerformance?.GET_INFO_USER_BY_ID_PERFORMANCE_EVAL;  

  useEffect(() => {
    if (EvaluationPerformanceInfoUser) {     
      setInfoEvaluationPerUser(EvaluationPerformanceInfoUser);
      setInfoEvaluationResults(EvaluationPerformanceInfoUser[0].evaluatorResults)
      setTypeEval(EvaluationPerformanceInfoUser[0].idTypeEvaluation)
      setInfoEvalCompetenceResults(EvaluationPerformanceInfoUser[0].infoByCompetence )
    }
  }, [EvaluationPerformanceInfoUser]);  
  
  const { data } = useQuery(GET_INFO_USER_BY_ADMIN_PERFORMANCE_EVAL, {
    variables: { idPerEval: id,  },
    skip: role !== 'admin', // No ejecutar la consulta si el rol no es 'admin'
  }); 

  
   useEffect(() => {
    if (role === 'admin' && data !== undefined) {
      const collaboratorsByAdmin = data.GET_INFO_USER_BY_ADMIN_PERFORMANCE_EVAL;
      if (collaboratorsByAdmin?.length > 0) {
        const sortedByBussinesName = [...collaboratorsByAdmin].sort((a, b) => {
          if (a.bussinesName < b.bussinesName) return -1;
          if (a.bussinesName > b.bussinesName) return 1;
          return 0;
        });        
        setArrayCollaborators(sortedByBussinesName);        
        setColEvalInit(sortedByBussinesName);
      }
    }
  }, [role,data]);  

  const { data: userByLeader } = useQuery(GET_INFO_USER_BY_LEADER_PERFORMANCE_EVAL, {
    variables: { idUser:idUser, idPerEval: performanceEvalId  },
    skip: role !== 'leader', 
  }); 

   useEffect(() => {
    if (role === 'leader' && userByLeader !== undefined) {      
       const collaboratorsByLeader = userByLeader.GET_INFO_USER_BY_LEADER_PERFORMANCE_EVAL;
       if (collaboratorsByLeader?.length > 0) {
         const sortedByBussinesName = [...collaboratorsByLeader].sort((a, b) => {
          if (a.bussinesName < b.bussinesName) return -1;
          if (a.bussinesName > b.bussinesName) return 1;
          return 0;
        });
        setArrayCollaborators(sortedByBussinesName);        
        setColEvalInit(sortedByBussinesName);
      }
    }
  }, [role,userByLeader]);  
    
  const [fetchInfoUserEvaluationPerformance, { data:infoUserEvalPerformance,}] = useLazyQuery(
    GET_INFO_USER_BY_ID_PERFORMANCE_EVAL,
    {
      variables: { idUser: selectIdColaborador, idPerEval: performanceEvalId },
      onCompleted: () => {     
      const EvaluationPerformanceInfoUser = infoUserEvalPerformance?.GET_INFO_USER_BY_ID_PERFORMANCE_EVAL;  
      if(EvaluationPerformanceInfoUser){
        setInfoEvaluationPerUser(EvaluationPerformanceInfoUser);
        setInfoEvaluationResults(EvaluationPerformanceInfoUser[0].evaluatorResults)
        setTypeEval(EvaluationPerformanceInfoUser[0].idTypeEvaluation)
        setInfoEvalCompetenceResults(EvaluationPerformanceInfoUser[0].infoByCompetence)        
        const numberCompetences=EvaluationPerformanceInfoUser[0].infoByCompetence.length
        const result= infoCalif(EvaluationPerformanceInfoUser[0].infoByCompetence)
        setIndicatorsReached((calcularCumplimiento(result)*100))       
        setMinEsperado( minEsperadoTotal(result))        
        const totalMinReq = result.reduce((sum: any, item: { minReq: any; }) => sum + item.minReq, 0);
        const totalCalification = result.reduce((sum: any, item: { CalificationByCompetence: any; }) => sum + item.CalificationByCompetence, 0);
        const califFinal=( totalCalification*100)/totalMinReq                
        setCalificacionNum(califFinal)        
        setCalificacionTxt(convertDesviacionToString((totalCalification/numberCompetences).toFixed(2)))
        setViewForCollaborator(true)
      }else{
        setMensajeColSel('No hay resultados disponibles para el colaborador seleccionado')
        setViewForCollaborator(false)
      }
      }
    }
  );

  useEffect(() => {
    if(selectIdColaborador !==0){
      fetchInfoUserEvaluationPerformance();
    }
  }, [fetchInfoUserEvaluationPerformance,selectIdColaborador]);

  const actionPlan = () => {
    console.log(id);
  };

  const sendActionPlan = async() => {
   LoadingAlert({ title: "Enviando..." }); 
   await senColPErEvaResult({
      variables:{                   
        idUser:selectIdColaborador,
        idPerEval:performanceEvalId
      }                 
  });
  SuccessfulAlert({ text: 'Correo electrónico enviado correctamente'})   
  };


  return (
    <>
      <Grid
        style={{
          backgroundColor: "#F5F6F9",
          minHeight: "calc(100vh - 74px)",
          padding: "50px 50px 0px 50px",
        }}
      >
        <Box mt={1} ml={1} className="Title" mb={1}>
          Resultados de evaluación
        </Box>
        <Grid>
          <Grid
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "10px",
              padding: "20px",
              marginTop: "20px",
              marginLeft: "10px",
              marginRight: "10px",
              height: "100%",
              width:"100%"
            }}
          >
            <Grid>
             <Grid className={getContainerClassInfo(role)}>
            {infoEvaluationPer.length > 0 && (
              <InfoEvaluationPerformance
                namePerformance={infoEvaluationPer[0].namePerformance}
                description={infoEvaluationPer[0].description}
                startPeriod={infoEvaluationPer[0].DateInit}
                endPeriod={infoEvaluationPer[0].DateEnd}
                type={infoEvaluationPer[0].tipoEvaluacion}
              />
             )            
            }
            {role ==='collaborator' &&(
             <Grid className="containerBtnsResultCOL">
              <BtnsEvalResult
                        txtBtn={"Planes de acción"}
                        funcExec={actionPlan}
                        icon={"add"}
                      />                    
                  </Grid>
              )}
            </Grid>
            {role !=='collaborator' ?
              <Grid>
                <SearcherColaboradorEval 
                setState={setArrayCollaborators}
                stateInitial={colEvalInit}
                />{" "}
              </Grid>:             
              infoEvaluationPerUser.length >0 &&(
              <Grid>
                <InfoEvalPerformanceCollaborator
                  nameComplete={infoEvaluationPerUser[0].fullName}
                  email={infoEvaluationPerUser[0].email}
                  sede={infoEvaluationPerUser[0].campus}
                  proyecto={infoEvaluationPerUser[0].project}
                  dateAdmission={infoEvaluationPerUser[0].dateAdmission}
                />
              </Grid>
              )        
            }
            </Grid>
            <Grid>
            <Grid className="containerColGraphs">
              {role !=='collaborator' &&(
               <Grid className="containerCol" >
                  <TableCollaborators
                  rows={arrayCollaborators}
                  setArrayIncident={setArrayIncident}
                  selected={selected}
                  setSelected={setSelected}
                  setViewForCollaborator={setViewForCollaborator}
                  setSelectIdColaborador={setSelectIdColaborador}
                  setMensajeColSel={setMensajeColSel}
                  />
                </Grid>
                )}
                { viewForCollaborator && role !== 'collaborator' && selectIdColaborador !==0 ? 
                <Grid className={getContainerClassQualification(role)}>
                {role !=='collaborator' &&( 
                  <Grid className="containerHeaderBtns">
                    <Grid className="containerQualificationResults">
                      <Grid>
                        <span className="qualificationResult">
                           Calificación
                        </span>
                      </Grid>
                      <Grid>
                        <span> | </span>
                      </Grid>
                      <Grid>
                        <span className="qualificationTxt">{calificacionTxt}</span>
                      </Grid>
                    </Grid>
                    <Grid className="containerBtnsResult">
                      <BtnsEvalResult
                        txtBtn={"Ver plan de acción"}
                        funcExec={actionPlan}
                        icon={"eye"}
                      />
                      <BtnsEvalResult
                        txtBtn={"Enviar"}
                        funcExec={sendActionPlan}
                        icon={"send"}
                      />
                      <BtnsEvalResult
                        txtBtn={"Descargar Reporte"}
                        funcExec={actionPlan}
                        icon={"download"}
                      />
                      <BtnsEvalResult
                        txtBtn={"Planes de acción"}
                        funcExec={actionPlan}
                        icon={"add"}
                      />  
                    </Grid>
                  </Grid>
                 )}
                
                   <Grid className={getContainerTypeEval(typeEval)}>
                    {
                    infoEvaluationResults.length >0 &&(  
                     infoEvaluationResults.map((row, index) => (
                      <ResultsEvaluators
                        info={row}
                        typeEvalExt={typeEval}
                        lastItem={index === infoEvaluationResults.length - 1}
                      />
                    )))
                  } 

                  </Grid>
                  <Grid className="containerGraphsInfo">
                  {infoEvaluationResults.length > 0 && (
                    <>
                      <div className="containerGraphsInfoBar">
                        <SimpleBarPlot data={getBarData(infoEvaluationResults)}  />
                      </div>
                      
                      <div className="containerGraphText">
                        <div className="containerTextoInformativo">
                          <div className="containerTextoInformativo-Title">Indicadores alcanzados</div>
                          <div className="containerTextoInformativo-NumerosP achieved-percentage">{indicatorsReached.toFixed(2)}%</div>
                          <div className="containerTextoInformativo-Sub">
                            <div>
                              <div className="info-title">Mínima esperada</div>
                              <div className="info-value expected-value">{minEsperado}%</div>
                            </div>
                            <div>
                              <div className="info-title">Obtenida</div>
                              <div className="info-value obtained-value">{indicatorsReached.toFixed(2)}%</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="containerGraphText">
                        <div className="containerTextoInformativo">
                          <div className="containerTextoInformativo-Title">Puntuación</div>
                          <div className="containerTextoInformativo-NumerosP score-percentage">{calificacionNUm >100 ? 100:calificacionNUm.toFixed(2)}%</div>
                          <div className="containerTextoInformativo-Sub">
                            <div>
                              <div className="info-title">Mínima esperada</div>
                              <div className="info-value expected-score">{minEsperado}%</div>
                            </div>
                            <div>
                              <div className="info-title">Obtenida</div>
                              <div className="info-value obtained-score">{calificacionNUm >100 ? 100:calificacionNUm.toFixed(2)}%</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  </Grid>
                  <Grid className="containerResIndicator">
                  {infoEvalCompetenceResults.length > 0 && (
                    <>
                        <div className="SpiderChart">
                          <SpiderChart
                          data={getSpiderData(infoEvalCompetenceResults)}
                          axisConfig={getSpiderConfig(infoEvalCompetenceResults)}
                          />
                        </div>
                      <div className="legendSpider">
                        <div className="legendSpider-Pack">
                          <div className="legendSpider-Title">Resultados por indicador</div>
                          <div className="legendSpider-Text2">Detalle de la puntuación obtenida para cada indicador agrupadas para su grupo correspondiente. El amarillo indica la puntuación de la autoevaluación, el rojo indica la puntuación minima y el azul la puntuación obtenida.</div>
                        </div>                           
                        <div className="legendSpider-Pack">
                          <div className="legendSpider-Text">Autoevaluación</div>
                          <span className="dot3"></span>
                        </div>
                        <div className="legendSpider-Pack">
                          <div className="legendSpider-Text">Minima esperada</div>
                          <span className="dot"></span>
                        </div>
                        <div className="legendSpider-Pack">
                          <div className="legendSpider-Text">Obtenida</div>
                          <span className="dot2"></span>
                        </div>
                      </div>
                    </>
                  )}
                  </Grid>
                  <Grid className="modelEvaluationRes">                  
                    {infoEvalCompetenceResults.length >0 &&(
                      <ModelsEvaluationResults
                        infoCompetencies={infoEvalCompetenceResults}
                      />
                     )}
                  </Grid>
                  <Grid className="modelEvaluationForRes">
                   {infoEvalCompetenceResults.length >0 &&(
                      <FortalezasPerformance
                        infoCompetencies={infoEvalCompetenceResults}
                      />
                    )}                  
                  </Grid>
                  <Grid className="modelOpportunityAreasRes">
                  {infoEvalCompetenceResults.length >0 &&(
                      <OpportunityAreas
                        infoCompetencies={infoEvalCompetenceResults}
                      />
                    )}                   
                  </Grid>
                </Grid>
                :role === 'collaborator' ?
                <Grid className={getContainerClassQualification(role)}>
                {role !=='collaborator' &&( 
                  <Grid className="containerHeaderBtns">
                    <Grid className="containerQualificationResults">
                      <Grid>
                        <span className="qualificationResult">
                          {" "}
                          Calificación
                        </span>{" "}
                      </Grid>
                      <Grid>
                        <span> | </span>{" "}
                      </Grid>
                      <Grid>
                        <span className="qualificationTxt">{calificacionTxt}</span>{" "}
                      </Grid>
                    </Grid>
                    <Grid className="containerBtnsResult">
                      <BtnsEvalResult
                        txtBtn={"Ver plan de acción"}
                        funcExec={actionPlan}
                        icon={"eye"}
                      />
                      <BtnsEvalResult
                        txtBtn={"Enviar"}
                        funcExec={actionPlan}
                        icon={"send"}
                      />
                      <BtnsEvalResult
                        txtBtn={"Descargar Reporte"}
                        funcExec={actionPlan}
                        icon={"download"}
                      />
                      <BtnsEvalResult
                        txtBtn={"Planes de acción"}
                        funcExec={actionPlan}
                        icon={"add"}
                      />  
                    </Grid>
                  </Grid>
                 )}
                 <Grid className={getContainerTypeEval(typeEval)}>
                    {
                    infoEvaluationResults.length >0 &&(  
                     infoEvaluationResults.map((row, index) => (
                      <ResultsEvaluators
                        info={row}
                        typeEvalExt={typeEval}
                        lastItem={index === infoEvaluationResults.length - 1}
                      />
                    )))
                  } 

                  </Grid>
                  <Grid className="containerGraphsInfo">
                  {infoEvaluationResults.length > 0 && (
                    <>
                      <div className="containerGraphsInfoBar">
                        <SimpleBarPlot data={getBarData(infoEvaluationResults)}  />
                      </div>
                      
                      <div className="containerGraphText" >
                        <div className="containerTextoInformativoCOL">
                          <div className="leftSIDE">
                            <div className="containerTextoInformativo-Title">Indicadores alcanzados</div>
                            <div className="containerTextoInformativo-NumerosPCOL achieved-percentage">{indicatorsReached.toFixed(2)}%</div>
                          </div>
                          
                          <div>
                            <div className="primeroColaboradorRE">
                              <div className="info-titleCOL">Mínima esperada</div>
                              <div className="info-value expected-value">{minEsperado}%</div>
                            </div>
                            <div>
                              <div className="info-titleCOL">Obtenida</div>
                              <div className="info-value obtained-value">{indicatorsReached.toFixed(2)}%</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="containerGraphText">
                        <div className="containerTextoInformativoCOL">
                          
                          <div className="leftSIDE">
                            <div className="containerTextoInformativo-Title">Puntuación</div>
                            <div className="containerTextoInformativo-NumerosPCOL score-percentage">{calificacionNUm >100 ? 100:calificacionNUm.toFixed(2)}%</div>
                          </div>
                          
                          <div>
                            <div className="primeroColaboradorRE">
                              <div className="info-titleCOL">Mínima esperada</div>
                              <div className="info-value expected-score">{minEsperado}%</div>
                            </div>
                            <div>
                              <div className="info-titleCOL">Obtenida</div>
                              <div className="info-value obtained-score">{calificacionNUm >100 ? 100:calificacionNUm.toFixed(2)}%</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                    </>
                  )}
                  </Grid>
                  <Grid className="containerResIndicatorCOL">
                  {infoEvalCompetenceResults.length > 0 && (
                    <>
                        <div className="SpiderChart">
                          <SpiderChart
                          data={getSpiderData(infoEvalCompetenceResults)}
                          axisConfig={getSpiderConfig(infoEvalCompetenceResults)}
                          />
                        </div>

                      <div className="legendSpiderColabCOL">

                          <div className="legendSpider-TitleCOL">Resultados por indicador</div>
                          <div className="legendSpider-Text2COL">Detalle de la puntuación obtenida para cada indicador agrupadas para su grupo correspondiente. El amarillo indica la puntuación de la autoevaluación, el rojo indica la puntuación minima y el azul la puntuación obtenida.</div>
                    
                        <div className="legendSpider-legend">
                          <div className="legend-item">
                            <div className="legendSpider-TextCOL">Autoevaluación</div>
                            <span className="dot3"></span>
                          </div>
                          <div className="legend-item">
                            <div className="legendSpider-TextCOL">Minima esperada</div>
                            <span className="dot"></span>
                          </div>
                          <div className="legend-item">
                            <div className="legendSpider-TextCOL">Obtenida</div>
                            <span className="dot2"></span>
                          </div>
                        </div>

                      </div>
                    </>
                  )}
                  </Grid>
                  <Grid className="modelEvaluationRes">                  
                    {infoEvalCompetenceResults.length >0 &&(
                      <ModelsEvaluationResults
                        infoCompetencies={infoEvalCompetenceResults}
                      />
                     )}
                  </Grid>
                  <Grid className="modelEvaluationForRes">
                   {infoEvalCompetenceResults.length >0 &&(
                      <FortalezasPerformance
                        infoCompetencies={infoEvalCompetenceResults}
                      />
                    )}                  
                  </Grid>
                  <Grid className="modelOpportunityAreasRes">
                  {infoEvalCompetenceResults.length >0 &&(
                      <OpportunityAreas
                        infoCompetencies={infoEvalCompetenceResults}
                      />
                    )}                   
                  </Grid>
                </Grid>
                :
                <Grid className={getContainerClassQualification(role)}>
                  <div>{mensajeColSel}</div>
                </Grid>
                }
              </Grid>
              </Grid>
            {role ==='admin' &&(
            <Grid
                    direction="row"
                    container
                    justify="flex-start"
                    alignItems="center"
                    style={{ marginTop: '20px' }}
                  >
                    <div>
                      <ArrowBackIcon
                        fontSize="small"
                        style={{ color: "#fabb00" }}
                      />
                    </div>
                    <span
                      className="Return"
                      style={{ marginTop: "0px" }}
                      onClick={() => {
                        history.push(`/evaluacionDesempeño`);
                      }}
                    >
                      Regresar a "Evaluaciones"
                    </span>
            </Grid>)
           }
          </Grid>         
        </Grid>        
      </Grid>
    </>
  );
};

export default PerformanceEvaluationResults;
